export default {
  vehicleGroups: state => state.vehicleGroups,
  selectedVehicleGroup: state => state.selectedVehicleGroup,
  vehicleGroupLicensePlates: state => state.vehicleGroupLicensePlates
}
